import { lazy } from 'react'

export const Email = lazy(() => import('./v1/Email'))
export const EmailV2 = lazy(() => import('./v2/EmailV2'))
export const EmailV3 = lazy(() => import('./v3/EmailV3'))
